import { connect } from 'react-redux'
import ReactDOM from 'react-dom'
import SpeedTest from '../../components/tools/SpeedTest.jsx'
import { AffixNewLinkText, AffixNewLinkQrcode, AffixNewLinkHangUp } from '../../components/affix/LinkTextNew.jsx'
import { DOMAIN, DOWNLOAD_WIN, DOMAIN_CHECK, DOWNLOAD_APP_QR,DOWNLOAD_HANGUP_PC, DOWNLOAD_HANGUP_README, ACTIVITY_SOUTHASIA, DOWNLOAD_APP_HANGUP_QR, DOWNLOAD_CEF_PC, DOWNLOAD_FAST_LOGIN, HY_DOWNLOAD_AUTOLOTT_PC,SPEEP_PC, DOWNLOAD_CENTER } from '../../constants/config'
import volidPng from '../../i/pc-day/login/sidebar_con_xclogo.png'
import login_logo from '../../i/pc-day/hy/login_logo.png'
import {UserCheckbox,ServiceBox} from './UserAgreement.jsx'

class Login extends React.Component {

  constructor(props) {
    super(props);
    this.login = this.login.bind(this);
    this.loginWithCaptcha = this.loginWithCaptcha.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.togglePasswordType = this.togglePasswordType.bind(this);

    this.state = {
      passwordType: true,
      display: true,
      showPassword: false,
      saveUser: $.getCookie('_username'),
    }
    // this.imgUrl = DOWNLOAD_APP_QR + "?n=" + Math.random()
    this.qrUrl = DOWNLOAD_APP_HANGUP_QR + "?n" + Math.random()
    this.autolottPC = HY_DOWNLOAD_AUTOLOTT_PC + "?n" + Math.random()
    this.downCenter = DOWNLOAD_CENTER + "?n=" + Math.random()
    document.getElementsByTagName('body')[0].style.background = '#fff'

  }

  componentDidMount(){
    this.props.$$COMMON.clearDomainStatus();
    this.props.$$COMMON.getSpeedDomains();
    // 记住上一次密码
    if ($.getCookie('_username') && $.getCookie('_password')) {
      $.setEleValueById('username', $.getCookie('_username'));
      $.setEleValueById('password', $.getCookie('_password'));
      let state = _.cloneDeep(this.state);
      state['username'] = $.getCookie('_username');
      state['password'] = $.getCookie('_password');
      this.setState(state)
    }
    this.refreshTimer = window.setInterval(function(){
      this.props.$$COMMON.getValidcode();
    }.bind(this), 60000);
  }

  componentWillUnmount(){
    if (this.refreshTimer) {
      window.clearInterval(this.refreshTimer);
    }
    document.getElementsByTagName('body')[0].style.background = '';
  }

  // 忘记密码
  togglePasswordType(){
    this.setState({
      passwordType: !this.state.passwordType
    })
  }

  // 键盘事件
  handleKeyDown(event){
    if (event.keyCode !== 13) {return;}
    if (this.props.__BASE.toJS().modal.overlay.display){return;}
    this.login();
  }

  // 改变输入
  handleOnChange(key){
    let state = _.cloneDeep(this.state);
    state[key] = $.getEleValueById(key)
    this.setState(state)
  }

  //清除输入框值
  clearInput(key){
    let state = _.cloneDeep(this.state);
    state[key] = '';
    $.setEleValueById(key, state[key]);
    this.setState(state)
  }

  //显示明文密码
  showChangePassword(){
    let passType = ReactDOM.findDOMNode( this.refs.password );
    this.state.showPassword ? passType.type = 'password' : passType.type = 'text'
    this.setState({
      showPassword: !this.state.showPassword
    })
  }

  // 登陆
  login(){
    if(this.props.__COMMON.toJS().settings.agreement&&this.userAlert.loginAlert()){
      return this.userAlert.loginAlert()
    }
    const captcha = this.props.__COMMON.toJS().captcha;
    const request = {
      username: this.state.username,
      password: this.state.password,
      validcode: 'd41d8cd98f00b204e9800998ecf8427e',
      saveUser: (this.state.passwordType && this.state.saveUser) ? true : false
    }
    this.props.$$MY.login(request);
  }

  // 使用验证码登陆
  loginWithCaptcha(validCode){
    const captcha = this.props.__COMMON.toJS().captcha;
    // 验证码
    if (!captcha) {
      return this.props.$$BASE.openAlert('请正确填写验证码信息');
    }

    const request = {
      username: this.state.username,
      password: this.state.password,
      validcode: $.Hex_MD5(validCode.toUpperCase()),
      saveUser: (this.state.passwordType && this.state.saveUser) ? true : false
    }
    this.props.$$MY.login(request, captcha.key + ':' + validCode);
  }

  // open(){
  //     this.props.$$BASE.openAlert('敬请期待！')
  // }

  handleNoChange(e){
    const localUrl = window.location.hostname;
    if(!e || e == localUrl){
      this.props.$$BASE.openAlert('当前域名已是最优线路！')
    }else{
      window.location.href = '//'+e;
    }
  }

  render() {
    const { captcha, showCaptcha, speedDomains, checkDomainResult, settings } = this.props.__COMMON.toJS();
    //speedDomains ? speedDomains.unshift({domain: window.location.host, key: "5", index: "99"}) : null;
    return (
      <div className="login-new-containers" style={{ display: this.state.display > 0 ? "block" : "none" }}>
        <div className="login-container">
          <img className="hy_login_logo" src={login_logo} alt="" />
          <div className="login-box" onKeyDown={this.handleKeyDown}>
            <a className="proxy-cer" href="https://www.xnpfstudio.com/" target="_black"></a>
            <a className="proxy-2-cer" href="https://www.jdcfwealth.com/" target="_black"></a>

            {settings && settings.agreement ? (
              <ServiceBox settings={settings} openAlert={this.props.$$BASE.openAlert} myClassName="loginServies" />
            ) : (
              <li className="service">
                <a href={settings ? settings["customer_service_url"] : "javascript;;"} target="_blank"></a>
              </li>
            )}
            <a href=""></a>
            <h2>&nbsp;</h2>
            <div className="input-box username">
              <i />
              <input type="text" id="username" onChange={() => this.handleOnChange("username")} placeholder="输入账号" />
            </div>
            <div className="input-box password">
              <i />
              <input
                type="password"
                ref="password"
                id="password"
                onChange={() => this.handleOnChange("password")}
                placeholder={this.state.passwordType ? "输入登录密码" : "enter the withdrawal password"}
              />
            </div>

            <div className="forgot-password clear">
              {this.state.passwordType && (
                <label className="fl rememberpass">
                  <input
                    name="checkbox"
                    type="checkbox"
                    id="remember"
                    defaultChecked={this.state.saveUser}
                    onClick={() => this.setState({ saveUser: !this.state.saveUser })}
                  />
                  <span className="checkPass"> 记住密码</span>
                </label>
              )}
              <a className="forgotpasswd pointer" onClick={this.togglePasswordType}>
                {this.state.passwordType ? "忘记密码" : "返回登录"}
              </a>
            </div>
            <a className="button-login pointer" onClick={this.login}>
              {this.state.passwordType ? "登录" : "提交"}
            </a>
            {settings && settings.agreement && (
              <UserCheckbox
                agrContent={settings.agreement}
                title="用户登录协议"
                openAlert={this.props.$$BASE.openAlert}
                onRef={(ref) => (this.userAlert = ref)}
              />
            )}
            <SpeedTest domains={speedDomains} handleNoChange={this.handleNoChange.bind(this)} />
            <a className="button-login-speed" href={SPEEP_PC}>
              <span className="button-login-img"></span>
              登录太慢? 点我切换最优线路
            </a>
          </div>
        </div>
        {showCaptcha ? (
          <ValidCodeModal
            action={this.loginWithCaptcha}
            captcha={captcha}
            closeFn={this.props.$$COMMON.toggleVaildCode}
            refreshValidcode={this.props.$$COMMON.getValidcode}
          />
        ) : null}
        <div className="client-download">
          <div className="box fast">
            <a target="_blank" href={DOWNLOAD_FAST_LOGIN}>
              <i></i>
              <h3>快速登录下载</h3>
              <p> 桌面一键启动</p>
            </a>
          </div>
          <div className="box computer">
            <a target="_blank" href={settings.pc_client_download_url}>
              <i></i>
              <h3>电脑客户端下载</h3>
              <p> 更稳定，更流畅</p>
            </a>
          </div>
          <div className="box code">
            <a href={this.downCenter} target="_blank">
              <i>
                <img src={settings.app_download_url} />
              </i>
              <h3>手机客户端下载</h3>
              <p>点击进入下载界面</p>
            </a>
          </div>
          <div className="box guaji">
            <a target="_blank" href={settings.hangup_pc_download_url}>
              <i></i>
              <h3>挂机软件下载</h3>
              <p>挂机赚钱，轻松赢</p>
            </a>
          </div>
        </div>
        <footer className="footer-container">
          <div className="frame-container">
            <div className="logo"></div>
            <p>Copyright &copy; HengYao 2017-2018 恒耀娱乐 版权所有 菲律宾政府PAGCOR博彩牌照认证</p>
          </div>
        </footer>
      </div>
    );
  }
}

reactMixin(Login.prototype, ImmutableMixin);

function mapStateToProps(state) {
  return {
    __BASE: state.base,
    __COMMON: state.common
  }
}

function mapDispatchToProps(dispatch) {
  return {
    $$MY: bindActionCreators(userAction, dispatch),
    $$BASE: bindActionCreators(baseAction, dispatch),
    $$COMMON: bindActionCreators(commonAction, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Login)


/**
 * 验证码输入框
 */
class ValidCodeModal extends React.Component {

  constructor(props) {
    super(props);
    this.handelClick = this.handelClick.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
    this.modalPosition = this.modalPosition.bind(this);
    this.state = {
      canSubmit: false
    }
    window.addEventListener('resize', this.modalPosition)
	  this.validCodeModal = null
  }

  componentDidMount(){
  	//获取ref是异步的，需要
  	setTimeout(()=>{
	    this.modalPosition()
	    this.refs.validcode.focus();
    },1000)

  }

  componentDidUpdate(){
    this.modalPosition()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.modalPosition, false);
  }

  modalPosition(){
    let modalTop = (window.document.body.offsetHeight - this.validCodeModal.offsetHeight) /2 - 20 + 'px';
    this.validCodeModal.style.top = modalTop;
  }

  handleInputChange(){
  }

  handelClick(){
    const { action } = this.props;
    let validcode = $.getEleValueById('validcode');
    validcode = _.trim(validcode);
    if(validcode.length != 4){
      return alert('请输入四位验证码!')
    }
    action(validcode);
  }

  // 键盘事件
  handleLogin(event){
    if (event.keyCode !== 13) {return;}
    this.handelClick();
  }

  render() {
    const { captcha, closeFn, refreshValidcode } = this.props;
    return (
        <div>
          <div className="code-box" ref={(node)=>{
          	this.validCodeModal=node
          }} onKeyDown={this.handleLogin}>
              <ul className="login_input">
                  <li className="validate-li"><i className="icon ic-code" />
                  <input type="text" id='validcode' maxLength='4' className="input-code" placeholder="输入验证码" />
                  <img src={captcha.image_url ? captcha.image_url : volidPng} title="点击刷新" className="validate pointer" onClick={refreshValidcode.bind(this)} />
                  </li>
                  <li><input type="button" id="submitLogin" value="确 定" className="submit-login submitLogin" onClick={this.handelClick} /></li>
              </ul>
          </div>
          <div className='overlay-mask' />
        </div>
    );
  }

}

